
import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_CONTRACT,
    GET_CONTRACTS,
    UPDATE_CONTRACT_ATTACHMENTS,
    GET_CONTRACTS_OUTGOING,
    GET_PROJECT_CONTRACTS,
    GET_PROJECT_CONTRACTS_OUTGOING,
    GET_CONTRACT_INVITATIONS,
    RESPOND_TO_CONTRACT_INVITATION,
    EDIT_CONTRACT,
    CLEAR_CONTRACTS,
    CREATE_CONTRACT,
    DELETE_CONTRACT,
    CLEAR_CONTRACT,
    CLEAR_INVITATIONS,
    GET_CONTRACT_INVITATION_COUNT,
    CLEAR_ALL_DROPS,
    GET_CONTRACT_DROPS,
    SET_CONTRACT_DROP,
    CLEAR_CONTRACTS_OUTGOING,
    GET_EX_ACCEPTED_CONTRACT,
    GET_NEW_ACCEPTED_CONTRACT,
    GET_CONTRACTS_INCLUDING_HIDDEN
} from "../actions/types";

const initialState = {
    contracts: [],
    noContractsExist: false,
    contractDrops: [],
    contract: {},
    contractDrop: {},
    invitations: [],
    noInvitationsExist: false,
    contractsOutgoing: [],
    noOutgoingContractsExist: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // ensure no redux values linger between users ----
        case LOGIN_SUCCESS:
        case LOGOUT_SUCCESS:
        case LOGOUT_FAIL:
            return {
                ...initialState,
            }
        // ------------------------------------------------  
        case GET_CONTRACTS_INCLUDING_HIDDEN:
        case GET_CONTRACTS:
            return {
                ...state,
                contracts: action.payload.contracts,
                noContractsExist: action.payload.contracts.length === 0 ? true : false,
                contractDrops: action.payload.contractDrops
            };
        case GET_PROJECT_CONTRACTS_OUTGOING:
        case GET_CONTRACTS_OUTGOING:
            return {
                ...state,
                contractsOutgoing: action.payload,
                noOutgoingContractsExist: action.payload.length === 0 ? true : false,
            };
        case CLEAR_CONTRACTS_OUTGOING:
            return {
                ...state,
                contractsOutgoing: [],
                noOutgoingContractsExist: false,
            };
        case UPDATE_CONTRACT_ATTACHMENTS:
            return {
                ...state,
                contract: { ...state.contract, attachments: action.payload }
            }
        case GET_CONTRACT_INVITATIONS:
            return {
                ...state,
                invitations: action.payload,
                noInvitationsExist: action.payload.length === 0 ? true : false,
            }
        case GET_CONTRACT_INVITATION_COUNT:
            return {
                ...state,
                noInvitationsExist: action.payload < 1 ? true : false,
            }
        case RESPOND_TO_CONTRACT_INVITATION:
            return {
                ...state,
                invitations: state.invitations.filter(invite => invite.role_id !== action.payload),
                noInvitationsExist: state.invitations.length - 1 < 1 ? true : false,
                // use payload (id) to map and remove invite w matching id
            }
        case GET_CONTRACT:
            return {
                ...state,
                contract: action.payload.contract,
                contractDrop: action.payload.contractDrop
            };
        case GET_EX_ACCEPTED_CONTRACT:
            return {
                ...state,
                contract: action.payload.contract,
                contractDrop: action.payload.contractDrop,
                contracts: state.contracts.map(contract => (contract.contract_id === action.payload.contract.contract_id) ? { ...contract, ...action.payload.contract } : contract),
                contractDrops: state.contractDrops.map(contractDrop => (contractDrop.contract_id === action.payload.contractDrop.contract_id) ? action.payload.contractDrop : contractDrop),
            };
        case GET_NEW_ACCEPTED_CONTRACT:
            // De-dupe by contract_id instead of trusting the caller's "existing" flag --
            // if the contract was already in state (e.g. from a stale check), update it
            // in place rather than appending a second copy.
            const contractAlreadyExists = state.contracts.some(contract => contract.contract_id === action.payload.contract.contract_id);
            const contractDropAlreadyExists = state.contractDrops.some(contractDrop => contractDrop.contract_id === action.payload.contractDrop.contract_id);
            return {
                ...state,
                contract: action.payload.contract,
                contractDrop: action.payload.contractDrop,
                contracts: contractAlreadyExists
                    ? state.contracts.map(contract => (contract.contract_id === action.payload.contract.contract_id) ? { ...contract, ...action.payload.contract } : contract)
                    : [...state.contracts, action.payload.contract],
                contractDrops: contractDropAlreadyExists
                    ? state.contractDrops.map(contractDrop => (contractDrop.contract_id === action.payload.contractDrop.contract_id) ? action.payload.contractDrop : contractDrop)
                    : [...state.contractDrops, action.payload.contractDrop],
            };

        case EDIT_CONTRACT:
            return {
                ...state,
                contracts: state.contracts.map(contract => (contract.contract_id === action.payload.contract.contract_id) ? { ...contract, ...action.payload.contract } : contract),
                contractDrops: state.contractDrops.map(contractDrop => (contractDrop.contract_id === action.payload.contractDrop.contract_id) ? action.payload.contractDrop : contractDrop),
                contract: { ...state.contract, ...action.payload.contract },
                contractDrop: action.payload.contractDrop,
            };
        case CREATE_CONTRACT:
            return {
                ...state,
                contracts: [...state.contracts, action.payload.contract],
                contractDrops: [...state.contractDrops, action.payload.contractDrop],
                contractDrop: action.payload.contractDrop,
                contract: action.payload.contract,
                noContractsExist: false,
                noOutgoingContractsExist: false,
            };
        case CLEAR_CONTRACTS:
            return {
                ...state,
                contracts: [],
                noContractsExist: false,
            };
        case CLEAR_INVITATIONS:
            return {
                ...state,
                invitations: [],
            };
        case CLEAR_CONTRACT:
            return {
                ...state,
                contract: {},
                contractDrop: {}
            };
        case DELETE_CONTRACT:
            return {
                ...state,
                contract: {},
                contracts: state.contracts.filter((contract) => contract.contract_id != action.payload),
                contractDrop: {},
                contractDrops: state.contractDrops.filter((contract) => contract.contract_id != action.payload),
                noContractsExist: state.contracts.length <= 1 ? true : false,
            };
        case GET_CONTRACT_DROPS:
            return {
                ...state,
                contractDrops: action.payload,
            };
        case CLEAR_ALL_DROPS:
            return {
                ...state,
                contractDrops: [],
            };
        case SET_CONTRACT_DROP:
            return {
                ...state,
                contractDrop: action.payload,
            };
        default:
            return state;
    }
}